export default __webpack_public_path__ + "tabCheck.svg";